export default "__VITE_ASSET__DpTnxR7z__"